import { ButtonList } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import type { Conversation } from 'lib-shared-types-api';
import { MouseEventHandler, useCallback } from 'react';

import { activityLogActions } from 'components/activityLog/actions/activityLog';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppNavigate } from 'utils/url/useAppNavigate';

type ConversationsTableRowMenuActivityLogProps = {
  /** The conversation. */
  conversation: Conversation;
};

/** Represents the component for viewing the conversation activity log. */
export const ConversationsTableRowMenuActivityLog = ({
  conversation,
}: ConversationsTableRowMenuActivityLogProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();

  /** Handles showing the activity log of the conversation. */
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(() => {
    dispatch(activityLogActions.toggle({ open: true }));

    navigate({
      path: '/conversation/:csid',
      params: { path: { csid: conversation.id.toString() } },
    });

    ampli.conversationActivityLogOpened({
      context: 'conversationsView',
    });
  }, [conversation.id, dispatch, navigate]);

  return (
    <ButtonList.Item onClick={handleClick}>View activity log</ButtonList.Item>
  );
};
